/**
 * region for libraries*/
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { Tab, Tabs } from '@material-ui/core';

/**
 * region for components*/
import SynonymsListKeyword from '../../components/keyword/SynonymsListKeyword';
import AttributesListKeyword from '../../components/keyword/AttributesListKeyword';
import ProductListKeyword from '../../components/keyword/ProductListKeyword';
import CounterProductKeyword from '../../components/keyword/CounterProductKeyword';
import { DetailHistoryKeyword } from '../../pages/keyword/activityLog/activity/DetailHistoryKeyword';

/**
 * region for styles*/
import { tabsKeywordStyle } from './style/tabsKeywordStyle';

class TabsKeyword extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedTab: 0,
            currentDetailRow:{
                IDENTITY:this.props.keyword.IDKEYWORD,
                IDCONTENTORGANIZATIONTYPE:1,
            }
        }
    }
    handleTabClick(event, newValue) {
        let self = this;
        self.setState({ selectedTab: newValue });
    }

    render() {
        const { classes, keyword } = this.props;
        let self = this;
        return (
            <div>
                <Tabs className={classes.marginTab}
                    value={this.state.selectedTab}
                    indicatorColor="primary"
                    variant="fullWidth"
                    onChange={self.handleTabClick.bind(this)}>
                    <Tab label="SYNONYMS" className={classes.tab}/>
                    <Tab label="ATTRIBUTES" className={classes.tab}/>
                    <Tab label="CONTENT" className={classes.tab}/>
                    <Tab label="ACTIVITY" className={classes.tab}/>
                </Tabs>
                <div className={classes.marginTab}>
                    {self.state.selectedTab === 0 &&
                        <SynonymsListKeyword
                            keyword={keyword} />
                    }
                    {self.state.selectedTab === 1 &&
                        <AttributesListKeyword
                            keyword={keyword} />
                    }
                    {self.state.selectedTab === 2 &&
                        <div className={classes.contentExpand}>
                            <CounterProductKeyword
                                keyword={keyword}/>
                            <ProductListKeyword
                                keyword={keyword} />
                        </div>}
                    {self.state.selectedTab === 3 &&
                        <DetailHistoryKeyword  detailParentRow={this.state.currentDetailRow} showOnlyTable={true}/>}
                </div>
            </div>
        );
    }
}
TabsKeyword.propTypes = {
    classes: PropTypes.object.isRequired
};
export default withStyles(tabsKeywordStyle)(TabsKeyword);





